module.exports = __webpack_public_path__ + "img/app-hero.385f0adb.jpg";